export type StudySessionRow = {
  id: string;
  user_id: string;
  resource_id: string | null;
  library_id: string | null;
  started_at: string;
  ended_at: string | null;
  duration_seconds: number;
  session_type: "reading" | "video";
  pages_read: number;
  created_at: string;
};

export function formatStudyDuration(totalSeconds: number): string {
  const safeSeconds = Math.max(0, Math.round(totalSeconds));
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);

  if (hours > 0 && minutes > 0) return `${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h`;
  if (minutes > 0) return `${minutes}m`;
  return `${safeSeconds}s`;
}

export function startOfLocalDay(date = new Date()): Date {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
}

export function getDateKey(dateInput: Date | string): string {
  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getLastNDays(count: number, from = new Date()): Date[] {
  return Array.from({ length: count }, (_, index) => {
    const day = new Date(from);
    day.setDate(from.getDate() - (count - index - 1));
    day.setHours(0, 0, 0, 0);
    return day;
  });
}

export function aggregateSessionsByDay(sessions: StudySessionRow[]) {
  return sessions.reduce<Record<string, number>>((acc, session) => {
    const key = getDateKey(session.started_at);
    acc[key] = (acc[key] || 0) + Number(session.duration_seconds || 0);
    return acc;
  }, {});
}

export function calculateStreak(dayTotals: Record<string, number>, from = new Date()): number {
  let streak = 0;
  const cursor = startOfLocalDay(from);

  while (dayTotals[getDateKey(cursor)] > 0) {
    streak += 1;
    cursor.setDate(cursor.getDate() - 1);
  }

  return streak;
}
